import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(9.0625, 3.5, 7, 3.5),
  },
  title: {
    textAlign: 'center',
  },
  scannerError: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  icon: {
    width: theme.spacing(8.375),
    height: theme.spacing(8.375),
    marginBottom: theme.spacing(3.75),
  },
  confirm: {
    marginTop: theme.spacing(5.0375),
  },
}));
